import { useCallback } from 'react';

import { getHeaderHeight } from '../../client/utils/functions';
import { getAdminBarHeight } from '../utils/functions';
import { PAGE_BODY, SCROLL_OFFSET } from '../utils/variables';

export const useScroll = <T extends Element>(
  ref: React.RefObject<T>,
  container = PAGE_BODY
) => {
  const scrollCallback = useCallback(() => {
    const scrollContainer = document.querySelector(container);

    if (scrollContainer === null) return;

    const element = ref.current;
    let position = 0;

    if (element) {
      const elementFromTop = element.getBoundingClientRect().top;
      const pageBodyScrollTop = scrollContainer.scrollTop;
      const headerHeight = getHeaderHeight() ?? 0;
      const adminBarHeight = getAdminBarHeight() ?? 0;

      position =
        elementFromTop +
        pageBodyScrollTop -
        headerHeight -
        adminBarHeight -
        SCROLL_OFFSET;
    }

    scrollContainer.scrollTo({ top: position, behavior: 'smooth' });
  }, [container, ref]);

  return scrollCallback;
};
